import axios from 'axios';

export const SERVICES_LOADING = 'SERVICES_LOADING';
export const SERVICES_SUCCESS = 'SERVICES_SUCCESS';
export const SERVICES_ERROR = 'SERVICES_ERROR';

export function fetchServices() {
  return async dispatch => {
    dispatch({ type: SERVICES_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/services`)
      .then(response => {
        dispatch({
          type: SERVICES_SUCCESS,
          payload: response
        });
      })
      .catch(result => {
        dispatch({
          type: SERVICES_ERROR,
          payload: result
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/serviceActions.js